import { render } from "./WaitingAnimation.vue?vue&type=template&id=809e5b9e"
import script from "./WaitingAnimation.vue?vue&type=script&lang=js"
export * from "./WaitingAnimation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__